import Image from 'next/image';
import React from 'react';
import ReactMarkdown from 'react-markdown';

import styles from '../styles/FaqAccordionItem.module.scss';

interface FaqAccordionItemProps {
  containerClass?: string;
  headerClass?: string;
  bodyClass?: string;
  onClick: (e: React.MouseEvent) => void;
  isActive: boolean;
  header: string;
  content: string;
  toggle_icon: { path: string; alt_text: string };
}

function FaqAccordionItem({
  containerClass = '',
  headerClass = '',
  bodyClass = '',
  onClick,
  isActive,
  header,
  content,
  toggle_icon,
}: FaqAccordionItemProps): React.ReactElement {
  return (
    <div className={`${styles['item']} ${containerClass}`}>
      <div
        className={`${styles['header-container']} ${isActive ? styles['active'] : ''}`}
        onClick={onClick}
      >
        <h3 className={`${styles['header']} ${headerClass}`}>{header}</h3>
        <div className={styles['arrow-icon']}>
          <Image
            src={toggle_icon.path}
            height={24}
            width={24}
            alt={toggle_icon.alt_text}
            quality={75}
          />
        </div>
      </div>
      <div
        className={`${styles['body']} ${isActive ? styles['active'] : styles['inactive']}`}
      >
        <div className={bodyClass}>
          <ReactMarkdown>{content}</ReactMarkdown>
        </div>
      </div>
    </div>
  );
}

export default FaqAccordionItem;
